import React, { useState } from "react";
import Button from "components/button";
import IndexModal from "components/modal";
import { DisconnectOutlined } from "@ant-design/icons";

const UnassignButton = ({
    supervisorItem, 
    form,              
    setSupervisors,      
    setSupervisorSelected, 
    label = "Unassign",
    modalTitle = "Confirm Unassign",
    className = "",
    unassignHandler,
}) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleConfirm = () => {
        if (!supervisorItem) return;

        const current = form.getFieldValue("supervisors") || [];
        const updated = current.filter(
        (s) => Number(s) !== Number(supervisorItem.supervisor.id)
        );
        form.setFieldsValue({ supervisors: updated });

        setSupervisors((prev) =>
        prev.filter((s) => s.supervisor.id !== supervisorItem.supervisor.id)
        );

        if (updated.length === 0 && setSupervisorSelected) {
        setSupervisorSelected(false);
        }
        if (unassignHandler) {
            console.log("test");
            unassignHandler();
        }
        handleClose();
    };

  return (
    <>
        <Button
            type="button"
            size="small"
            className={`crud-button btn-small text-sm text-red-700 hover:text-white ${className}`}
            onClick={handleOpen}
        >
            <DisconnectOutlined className="transition-colors" />
            {label}
        </Button>

        <IndexModal open={open} onClose={handleClose} title={modalTitle} width={400}>
            <div className="p-2">
            <div className="mb-6">
                <div className='content-wrapper'>
                    Are you sure you want to unassign{" "}
                    <strong>{supervisorItem?.supervisor.name}</strong>?
                </div>
            </div>

            <div className="flex justify-end gap-3">
                <Button className="btn-primary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button className="btn-primary" onClick={handleConfirm}>
                    Confirm
                </Button>
            </div>
            </div>
        </IndexModal>
    </>
  );
};

export default UnassignButton;
